export default __webpack_public_path__ + "static/badge-9df0881fcf6c0d68edb8d148c90d30bb.png";